import {createGlobalStyle} from "styled-components";
import fonts from "./fonts";

export default createGlobalStyle`
  ${fonts}
`
